// Auto-assign checks every report in its range and then re-checks every lot, so a long range
// takes minutes (a year of production data: about 3), past the app's 60-second request limit.
// Run it as consecutive windows of at most `days` days instead: each is quick, and together
// they cover the range exactly once.
export function autoAssignWindows(startDate, endDate, days = 30) {
  const toDate = (s) => new Date(`${s}T00:00:00Z`);
  const fmt = (d) => d.toISOString().slice(0, 10);
  const end = toDate(endDate);
  let from = toDate(startDate);
  if (isNaN(from) || isNaN(end) || from > end) return [];
  const windows = [];
  while (from <= end) {
    const to = new Date(from);
    to.setUTCDate(to.getUTCDate() + days - 1);
    const last = to < end ? to : end;
    windows.push({ startTime: fmt(from), endTime: fmt(last) });
    from = new Date(last);
    from.setUTCDate(from.getUTCDate() + 1);
  }
  return windows;
}

const COUNTS = ["checked", "assigned", "ambiguous", "relinked", "unlinked", "flagged"];

export function addAutoAssignCounts(total, part) {
  const sum = { ...total };
  COUNTS.forEach((k) => {
    sum[k] = (sum[k] || 0) + ((part && part[k]) || 0);
  });
  return sum;
}

// The `months` months up to and including `today`, as YYYY-MM-DD in local time: the lab result
// page's default range. 4 Jan gives 4 Oct to 4 Jan, never an almost empty new quarter.
export function lastMonthsRange(today, months) {
  const pad = (n) => String(n).padStart(2, "0");
  const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  const start = new Date(today.getFullYear(), today.getMonth() - months, today.getDate());
  // 31 May minus 3 months is 31 Feb, which Date rolls into March: use the last day of February.
  if (start.getDate() !== today.getDate()) start.setDate(0);
  return { startDate: fmt(start), endDate: fmt(today) };
}
